<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขบริการเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <div class="pa-3">
                <div class="mb-3">
                    <h2>บริการ</h2>
                </div>
                <div class="d-flex justify-space-between align-center mb-3">
                    <div>
                        อัพเดทล่าสุด : {{detail_content.date_update }} โดย {{ detail_content.user_update }}
                    </div>
                    <v-btn height="65" width="20%" color="#28ab28" class="white--text" @click="editService()">
                        แก้ไข
                    </v-btn>

                </div>
                <div>
                    <quillEditor ref="myQuillEditor" v-model="content" :options="$store.state.editorOption" />
                </div>
            </div>
        </v-card>

    </div>
</div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import Quill from 'quill'
import {
    ImageDrop
} from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

import {
    quillEditor
} from 'vue-quill-editor'
import contentservice from '@/api/content/contentsetting/contentservice.js'
export default {
    components: {
        quillEditor
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show_edit: false,
            detail_content: null,
            content: '',
        }
    },
    computed: {
        editor() {
            return this.$refs.myQuillEditor.quill
        }
    },
    methods: {
        async contentServiceList() {
            this.loading_page = true
            this.detail_content = null
            this.content = ''
            contentservice.serviceList().then((response) => {
                if (response.data.successful === true) {
                    this.detail_content =  response.data.service
                    this.content = response.data.service.service
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async editService() {
            const data = {
                service: this.content,
            }
            contentservice.editService(data).then((response) => {
                if (response.data.successful === true) {
                    this.contentServiceList()
                    this.alert_show_edit = true
                    setTimeout(() => this.alert_show_edit = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

        }
    },
    mounted() {
        this.contentServiceList()
    }
}
</script>
